export default __webpack_public_path__ + "static/media/Armguards of the Proven Champion.7091c150.jpg";